// Helper functions
import { colorMap, iconMap } from '@/utils/constant';
const getColor = label => {
  return 'x';
  //return colorMap[label] || "#CCCCCC"; // Default color if label not found
};

const getIcon = label => {
  return 'x';
  //return //iconMap[label] || "default-icon.png"; // Default icon if label not found
};

// Main function
export function Processor(nodesData, edgesData) {
  // Function to handle label changes when "bucket" is found
  function handleBucketLabel(node) {
    if (node.data?.label && /bucket/i.test(node.data.label)) {
      return node.data?.elemProps['id']; // Return id if label contains "bucket"
    }
    return node.data?.label;
  }

  // Process nodes
  const processedNodes = nodesData.map(node => {
    // Determine the class for the node (S3 or default)
    const nodeClass = /bucket/i.test(node.data?.label) ? 's3bucket' : node.data?.label;

    const processedLabel =
      handleBucketLabel(node) === 'AWSAccount' ? 'Attacker' : handleBucketLabel(node);

    return {
      label: processedLabel, // Retain the processed label
      id: node.id,
      color: getColor(node.data?.label),
      icon: getIcon(node.data?.label),
      class: nodeClass, // Add class for S3 or default
    };
  });

  // Find the "Attacker" node
  const attackerNode = processedNodes.find(node => node.label === 'Attacker');

  // Find the "Elastic IP Address" node
  const elasticIPNode = processedNodes.find(
    node =>
      /ipaddress|elastic ipaddress/i.test(node.id) ||
      /ipaddress|elastic ipaddress/i.test(node.label)
  );

  // If "Elastic IP Address" not found, fallback to the fixed label "EC2Instance"
  const targetNode = elasticIPNode || processedNodes.find(node => node.label === 'EC2Instance');

  // Process edges
  const processedEdges = [...edgesData];

  // Add a new edge if both "Attacker" and target nodes exist
  if (attackerNode && targetNode) {
    processedEdges.push({
      source: attackerNode.id, // Connect from "Attacker"
      target: targetNode.id, // Connect to Elastic IP or EC2Instance
    });
  }

  return { nodes: processedNodes, edges: processedEdges };
}
